import config from '@/config'
const bucket_url = config.bucketUrl

const addToCalendarButtonTemplate = `
<div style="text-align: left; margin-top: 28px;">
  <p style="font-weight: 500; line-height: 4px; text-align: left;">Add to
    Calendar</p><br>
  <a href="{{base_url}}/google/calendar/add-event/{{event_id}}"
    style="display: inline-block; padding: 10px 16px; border-radius: 8px; border: 1px solid #D0D5DD; color: #344054; cursor: pointer; text-decoration: none;"
    target="_blank"><img style="width:16px;height:16px;vertical-align:middle;margin-right:4px;border-style: none;padding: 2px 2px;"
      src="${bucket_url}/g-calendar.png" />Google</a>
  <a href="{{base_url}}/google/calendar/get-ics/{{event_id}}"
    style="display: inline-block; margin: 0 15px; padding: 10px 16px; border-radius: 8px; border: 1px solid #D0D5DD;color: #344054; cursor: pointer; text-decoration: none;"
    target="_blank"><img style="width:16px;height:16px;vertical-align:middle;margin-right:4px;border-style: none;padding: 2px 2px;"
      src="${bucket_url}/ms_outlook.png" />Outlook</a>
  <a href="{{base_url}}/google/calendar/get-ics/{{event_id}}"
    style="display: inline-block; padding: 10px 16px; border-radius: 8px; border: 1px solid #D0D5DD;color: #344054; cursor: pointer; text-decoration: none;"
    target="_blank"><img style="width:16px;height:16px;vertical-align:middle;margin-right:4px;border-style: none;padding: 2px 2px;"
      src="${bucket_url}/iCal.png" />iCloud</a>
</div>
`

// ------------------- Unconfirmed events -------------------

const defaultEmailSubjectForUserForNewEvents = `New Appointment Requested by {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForUserForNewEvents = `
Hi,
<br><br>
A new appointment has been requested by {{contact.name}}. Please review the details below and confirm the appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
Contact Name: {{contact.name}}<br>
<br><br>
Click below to approve, reschedule, or cancel the request.
<br><br>
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr>
<td>
<table border="0" cellspacing="0" cellpadding="0">
<tr>
<td bgcolor="#EB7035" style="padding: 10px 9px 10px 9px;border-radius:3px;background-color: #37ca37;" align="center">
<a href="{{appointment_link}}" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; color: #ffffff; text-decoration: none; display: inline-block;">Review Request &rarr;</a>
</td>
</tr>
</table>
</td>
</tr>
</table>
`

const defaultEmailForUserForNewEvents = {
  subject: defaultEmailSubjectForUserForNewEvents,
  html: defaultEmailBodyForUserForNewEvents,
}

const defaultEmailSubjectForContactForNewEvents = `Appointment Request Received for {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForContactForNewEvents = `
Hi {{contact.name}},
<br><br>
We’ve received your appointment request and will confirm it shortly.
<br><br>
Here are the details of your requested appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
<br><br><br>
`

const defaultEmailForContactForNewEvents = {
  subject: defaultEmailSubjectForContactForNewEvents,
  html: defaultEmailBodyForContactForNewEvents,
}

const defaultEmailSubjectForGuestForNewEvents = `You've Been Invited to an Appointment on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForGuestForNewEvents = `
Hi {{guest.name}},
<br><br>
You have been invited to an appointment by {{contact.name}}. Here are the details of your upcoming appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailForGuestForNewEvents = {
  subject: defaultEmailSubjectForGuestForNewEvents,
  html: defaultEmailBodyForGuestForNewEvents,
}

const defaultSmsTextForUserForNewEvents = {
  text: `New appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}).`
}
const defaultSmsTextForContactForNewEvents = {
  text: `Hi {{contact.name}}, 
Your appointment is requested for {{appointment.start_time}} ({{appointment.timezone}}). We’ll confirm it shortly.
  `
}

// ------------------- Confirmed events -------------------

const defaultEmailSubjectForUserForConfirmedEvents = `Appointment Confirmation of {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForUserForConfirmedEvents = `
Hi,
<br><br>
Your appointment has been scheduled with {{contact.name}}. Here are the details of your upcoming appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
Contact Name: {{contact.name}}<br>
<br><br>
Click below to approve, reschedule, or cancel the request.
<br><br>
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tr>
<td>
<table border="0" cellspacing="0" cellpadding="0">
<tr>
<td bgcolor="#EB7035" style="padding: 10px 9px 10px 9px;border-radius:3px;background-color: #37ca37;" align="center">
<a href="{{appointment_link}}" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; color: #ffffff; text-decoration: none; display: inline-block;">Review Request &rarr;</a>
</td>
</tr>
</table>
</td>
</tr>
</table>
`

const defaultEmailForUserForConfirmedEvents = {
  subject: defaultEmailSubjectForUserForConfirmedEvents,
  html: defaultEmailBodyForUserForConfirmedEvents,
}

const defaultEmailSubjectForContactForConfirmedEvents = `Appointment Confirmation on {{appointment.start_time}} ({{appointment.timezone}})`

const defaultEmailBodyForContactForConfirmedEvents = `
Hi {{contact.name}},
<br><br>
Your appointment has been scheduled. Here are the details of your upcoming appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailForContactForConfirmedEvents = {
  subject: defaultEmailSubjectForContactForConfirmedEvents,
  html: defaultEmailBodyForContactForConfirmedEvents,
}

const defaultEmailSubjectForGuestForConfirmedEvents = `Appointment Confirmation on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForGuestForConfirmedEvents = `
Hi {{guest.name}},
<br><br>
You have been invited to an appointment by {{contact.name}}. Here are the details of your upcoming appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailForGuestForConfirmedEvents = {
  subject: defaultEmailSubjectForGuestForConfirmedEvents,
  html: defaultEmailBodyForGuestForConfirmedEvents,
}

const defaultEmailBodyForGuestForConfirmedEventsWithCustomLink = `
Hi {{guest.name}},
<br><br>
You have been invited to an appointment by {{contact.name}}. Here are the details of your upcoming appointment:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link: {{appointment.meeting_location}}<br>
The appointment organizer has requested additional information. Please <a href="{{calendar.form_link}}">click here</a> to provide the requested details.<br>

In case the above link does not work you can use this link {{calendar.form_link}}<br>
`
const defaultEmailForGuestForConfirmedEventsWithCustomLink = {
  subject: defaultEmailSubjectForGuestForConfirmedEvents,
  html: defaultEmailBodyForGuestForConfirmedEventsWithCustomLink,
}

const defaultSmsTextForUserForConfirmedEvents = {
  text: `Confirmed: Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}).`
}
const defaultSmsTextForContactForConfirmedEvents = {
  text: `Hi {{contact.name}},
Your appointment is confirmed for {{appointment.start_time}} ({{appointment.timezone}}).
  `
}

// ------------------- Cancelled events -------------------

const defaultEmailSubjectForUserForCancelledEvents = `Cancelled: Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForUserForCancelledEvents = `
Hi,
<br><br>
Your appointment with {{contact.name}}, originally scheduled for {{appointment.start_time}} ({{appointment.timezone}}), has been cancelled.
<br><br>
Here are the details for reference:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
Contact Name: {{contact.name}}<br>
<br><br>
`
const defaultEmailForUserForCancelledEvents = {
  subject: defaultEmailSubjectForUserForCancelledEvents,
  html: defaultEmailBodyForUserForCancelledEvents,
}

const defaultEmailSubjectForContactForCancelledEvents = `Appointment Cancelled: {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForContactForCancelledEvents = `
Hi {{contact.name}},
<br><br>
We regret to inform you that your upcoming appointment, originally scheduled for {{appointment.start_time}} ({{appointment.timezone}}), has been cancelled.
<br><br>
Here are the details for your reference:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
`
const defaultEmailForContactForCancelledEvents = {
  subject: defaultEmailSubjectForContactForCancelledEvents,
  html: defaultEmailBodyForContactForCancelledEvents,
}

const defaultEmailSubjectForGuestForCancelledEvents = `Appointment Cancelled: {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForGuestForCancelledEvents = `
Hi {{guest.name}},
<br><br>
We regret to inform you that your upcoming appointment, originally scheduled for {{appointment.start_time}} ({{appointment.timezone}}), has been cancelled.
<br><br>
Here are the details for your reference:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
`
const defaultEmailForGuestForCancelledEvents = {
  subject: defaultEmailSubjectForGuestForCancelledEvents,
  html: defaultEmailBodyForGuestForCancelledEvents,
}

const defaultSmsTextForUserForCancelledEvents = {
  text: `Cancelled: Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}).`
}
const defaultSmsTextForContactForCancelledEvents = {
  text: `Hi {{contact.name}}, 
Your appointment on {{appointment.start_time}} ({{appointment.timezone}}) has been cancelled.
  `
}

// ------------------- Rescheduled events -------------------

const defaultEmailSubjectForUserForRescheduledEvents = `Appointment Rescheduled: {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForUserForRescheduledEvents = `
Hi,
<br><br>
Your appointment with {{contact.name}} has been rescheduled. Below are the updated details:
<br><br>
Appointment Title: {{appointment.title}}<br>
New Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
Contact Name: {{contact.name}}<br>
<br><br>
`
const defaultEmailForUserForRescheduledEvents = {
  subject: defaultEmailSubjectForUserForRescheduledEvents,
  html: defaultEmailBodyForUserForRescheduledEvents,
}

const defaultEmailSubjectForContactForRescheduledEvents = `Appointment Rescheduled to {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForContactForRescheduledEvents = `
Hi {{contact.name}},
<br><br>
Your upcoming appointment has been rescheduled. Here are the updated details:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailBodyForGuestForRescheduledEvents = `
Hi {{guest.name}},
<br><br>
Your upcoming appointment has been rescheduled. Here are the updated details:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailForContactForRescheduledEvents = {
  subject: defaultEmailSubjectForContactForRescheduledEvents,
  html: defaultEmailBodyForContactForRescheduledEvents,
}

const defaultEmailForGuestForRescheduledEvents = {
  subject: defaultEmailSubjectForContactForRescheduledEvents,
  html: defaultEmailBodyForGuestForRescheduledEvents,
}

const defaultSmsTextForUserForRescheduledEvents = {
  text: `Rescheduled: Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}).`
}
const defaultSmsTextForContactForRescheduledEvents = {
  text: `Hi {{contact.name}}, 
Your appointment has been rescheduled to {{appointment.start_time}} ({{appointment.timezone}}).
  `
}

// ------------------- Reminders -------------------

const defaultEmailSubjectForUserReminder = `Reminder: Upcoming Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForUserReminder = `
Hi,
<br><br>
This is a reminder of your upcoming appointment with {{contact.name}}. Please review the details below:
<br><br>
Appointment Title: {{appointment.title}}<br>
New Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
Contact Name: {{contact.name}}<br>
<br><br>
`
const defaultEmailForUserForReminders = {
  subject: defaultEmailSubjectForUserReminder,
  html: defaultEmailBodyForUserReminder,
}

const defaultEmailSubjectForContactForReminder = `Reminder: Upcoming Appointment on {{appointment.start_time}} ({{appointment.timezone}})`
const defaultEmailBodyForContactForReminder = `
Hi {{contact.name}},
<br><br>
This is a friendly reminder about your upcoming appointment. Here are the details:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`

const defaultEmailBodyForGuestForReminder = `
Hi {{guest.name}},
<br><br>
This is a friendly reminder about your upcoming appointment. Here are the details:
<br><br>
Appointment Title: {{appointment.title}}<br>
Date and Time: {{appointment.start_time}} ({{appointment.timezone}})<br>
Meeting Link / Location: {{appointment.meeting_location}}<br>
${addToCalendarButtonTemplate}
`
const defaultEmailForContactForReminder = {
  subject: defaultEmailSubjectForContactForReminder,
  html: defaultEmailBodyForContactForReminder,
}

const defaultEmailForGuestForReminder = {
  subject: defaultEmailSubjectForContactForReminder,
  html: defaultEmailBodyForGuestForReminder,
}

const defaultSmsTextForUserForReminder = {
  text: `Reminder: Upcoming appointment with {{contact.name}} at {{appointment.start_time}} ({{appointment.timezone}}).`
}
const defaultSmsTextForContactForReminder = {
  text: `Hi {{contact.name}}, 
This is a friendly reminder about your upcoming appointment at {{appointment.start_time}} ({{appointment.timezone}}).
  `
}

// ------------------- Follow-ups -------------------

const defaultEmailSubjectForUserFollowup = `Follow-Up: Appointment Completed with {{contact.name}}`
const defaultEmailBodyForUserFollowup = `
Hi,
<br><br>
You have completed your appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}). This is a follow-up email to ensure all relevant details have been successfully updated in the system.
<br><br>
If you have any additional notes or feedback about the appointment, please feel free to share.
<br><br>
`
const defaultEmailForUserForFollowup = {
  subject: defaultEmailSubjectForUserFollowup,
  html: defaultEmailBodyForUserFollowup,
}

const defaultEmailSubjectForContactForFollowup = `We’d love your feedback on your recent appointment!`
const defaultEmailBodyForContactForFollowup = `
Hi {{contact.name}},
<br><br>
Thank you for attending the appointment on {{appointment.start_time}} ({{appointment.timezone}}). We’d love to hear your feedback!
<br><br>
Feel free to reply directly to this email with your thoughts.
${addToCalendarButtonTemplate}
`
const defaultEmailBodyForGuestForFollowup = `
Hi {{guest.name}},
<br><br>
Thank you for attending the appointment on {{appointment.start_time}} ({{appointment.timezone}}). We’d love to hear your feedback!
<br><br>
Feel free to reply directly to this email with your thoughts.
${addToCalendarButtonTemplate}
`
const defaultEmailForContactForFollowup = {
  subject: defaultEmailSubjectForContactForFollowup,
  html: defaultEmailBodyForContactForFollowup,
}

const defaultEmailForGuestForFollowup = {
  subject: defaultEmailSubjectForContactForFollowup,
  html: defaultEmailBodyForGuestForFollowup,
}

const defaultSmsTextForUserForFollowup = {
  text: `Appointment with {{contact.name}} on {{appointment.start_time}} ({{appointment.timezone}}) is completed.`
}
const defaultSmsTextForContactForFollowup = {
  text: `Hi {{contact.name}},
Thank you for your appointment on {{appointment.start_time}} ({{appointment.timezone}}). Please share your feedback with us.
  `
}

export const inAppNotificationTemplate = {
  booked: {
    title: `New Appointment Booked`,
    body: `You have a new appointment booked with {{contact.name}}`,
  },
  confirmation: {
    title: `Appointment Confirmed`,
    body: `Appointment with {{contact.name}} is confirmed`,
  },
  cancellation: {
    title: `Appointment Cancelled`,
    body: `Appointment with {{contact.name}} is cancelled`,
  },
  reschedule: {
    title: `Appointment Rescheduled`,
    body: `Appointment with {{contact.name}} is rescheduled`,
  },
  reminder: {
    title: `Appointment Reminder`,
    body: `Appointment with {{contact.name}} is starting in `,
  },
  followup: {
    title: `Appointment Follow-up`,
    body: `Reminder to follow-up regarding your appointment with {{contact.name}}`,
  },
}

const defaultWhatsappTextForUserForNewEvents = 'calendar_notification_appointment_booked_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForNewEvents = 'calendar_notification_appointment_booked_contact_1'
const defaultWhatsappTextForUserForConfirmedEvents = 'calendar_notification_appointment_confirmed_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForConfirmedEvents = 'calendar_notification_appointment_confirmed_contact_1'
const defaultWhatsappTextForUserForCancelledEvents = 'calendar_notification_appointment_cancelled_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForCancelledEvents = 'calendar_notification_appointment_cancelled_contact_1'
const defaultWhatsappTextForUserForRescheduledEvents = 'calendar_notification_appointment_rescheduled_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForRescheduledEvents = 'calendar_notification_appointment_rescheduled_contact_1'
const defaultWhatsappTextForUserForReminder = 'calendar_notification_appointment_reminder_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForReminder = 'calendar_notification_appointment_reminder_contact_1'
const defaultWhatsappTextForUserForFollowup = 'calendar_notification_appointment_followup_assigned_user_additional_numbers_1'
const defaultWhatsappTextForContactForFollowup = 'calendar_notification_appointment_followup_contact_1'


const DEFAULT_TEMPLATES = {
  booked: {
    assignedUser: {
      email: defaultEmailForUserForNewEvents,
      sms: defaultSmsTextForUserForNewEvents,
      whatsapp: defaultWhatsappTextForUserForNewEvents,
    },
    emails: {
      email: defaultEmailForUserForNewEvents,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForNewEvents,
      whatsapp: defaultWhatsappTextForUserForNewEvents,
    },
    contact: {
      email: defaultEmailForContactForNewEvents,
      sms: defaultSmsTextForContactForNewEvents,
      whatsapp: defaultWhatsappTextForContactForNewEvents,
    },
    guest: {
      email: defaultEmailForGuestForNewEvents,
      sms: defaultSmsTextForContactForNewEvents,
      whatsapp: defaultWhatsappTextForContactForNewEvents,
    },
  },
  confirmation: {
    assignedUser: {
      email: defaultEmailForUserForConfirmedEvents,
      sms: defaultSmsTextForUserForConfirmedEvents,
      whatsapp: defaultWhatsappTextForUserForConfirmedEvents,
    },
    emails: {
      email: defaultEmailForUserForConfirmedEvents,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForConfirmedEvents,
      whatsapp: defaultWhatsappTextForUserForConfirmedEvents,
    },
    contact: {
      email: defaultEmailForContactForConfirmedEvents,
      sms: defaultSmsTextForContactForConfirmedEvents,
      whatsapp: defaultWhatsappTextForContactForConfirmedEvents,
    },
    guest: {
      email: {
        default: defaultEmailForGuestForConfirmedEvents,
        customLink: defaultEmailForGuestForConfirmedEventsWithCustomLink,
      },
      sms: defaultSmsTextForContactForConfirmedEvents,
      whatsapp: defaultWhatsappTextForContactForConfirmedEvents,
    },
  },
  cancellation: {
    assignedUser: {
      email: defaultEmailForUserForCancelledEvents,
      sms: defaultSmsTextForUserForCancelledEvents,
      whatsapp: defaultWhatsappTextForUserForCancelledEvents,
    },
    emails: {
      email: defaultEmailForUserForCancelledEvents,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForCancelledEvents,
      whatsapp: defaultWhatsappTextForUserForCancelledEvents,
    },
    contact: {
      email: defaultEmailForContactForCancelledEvents,
      sms: defaultSmsTextForContactForCancelledEvents,
      whatsapp: defaultWhatsappTextForContactForCancelledEvents,
    },
    guest: {
      email: defaultEmailForGuestForCancelledEvents,
      sms: defaultSmsTextForContactForCancelledEvents,
      whatsapp: defaultWhatsappTextForContactForCancelledEvents,
    },
  },
  reschedule: {
    assignedUser: {
      email: defaultEmailForUserForRescheduledEvents,
      sms: defaultSmsTextForUserForRescheduledEvents,
      whatsapp: defaultWhatsappTextForUserForRescheduledEvents,
    },
    emails: {
      email: defaultEmailForUserForRescheduledEvents,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForRescheduledEvents,
      whatsapp: defaultWhatsappTextForUserForRescheduledEvents,
    },
    contact: {
      email: defaultEmailForContactForRescheduledEvents,
      sms: defaultSmsTextForContactForRescheduledEvents,
      whatsapp: defaultWhatsappTextForContactForRescheduledEvents,
    },
    guest: {
      email: defaultEmailForGuestForRescheduledEvents,
      sms: defaultSmsTextForContactForRescheduledEvents,
      whatsapp: defaultWhatsappTextForContactForRescheduledEvents,
    },
  },
  reminder: {
    assignedUser: {
      email: defaultEmailForUserForReminders,
      sms: defaultSmsTextForUserForReminder,
      whatsapp: defaultWhatsappTextForUserForReminder,
    },
    emails: {
      email: defaultEmailForUserForReminders,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForReminder,
      whatsapp: defaultWhatsappTextForUserForReminder,
    },
    contact: {
      email: defaultEmailForContactForReminder,
      sms: defaultSmsTextForContactForReminder,
      whatsapp: defaultWhatsappTextForContactForReminder,
    },
    guest: {
      email: defaultEmailForGuestForReminder,
      sms: defaultSmsTextForContactForReminder,
      whatsapp: defaultWhatsappTextForContactForReminder,
    },
  },
  followup: {
    assignedUser: {
      email: defaultEmailForUserForFollowup,
      sms: defaultSmsTextForUserForFollowup,
      whatsapp: defaultWhatsappTextForUserForFollowup,
    },
    emails: {
      email: defaultEmailForUserForFollowup,
    },
    phoneNumbers: {
      sms: defaultSmsTextForUserForFollowup,
      whatsapp: defaultWhatsappTextForUserForFollowup,
    },
    contact: {
      email: defaultEmailForContactForFollowup,
      sms: defaultSmsTextForContactForFollowup,
      whatsapp: defaultWhatsappTextForContactForFollowup,
    },
    guest: {
      email: defaultEmailForGuestForFollowup,
      sms: defaultSmsTextForContactForFollowup,
      whatsapp: defaultWhatsappTextForContactForFollowup,
    },
  },
}
export function getDefaultWhatsAppTemplateLabel(
  notificationType: string,
  receiverType: string
): string | null {
  try {
    const notificationTemplates = DEFAULT_TEMPLATES[notificationType]
    const receiverTemplates = notificationTemplates?.[receiverType]
    const defaultLabel = receiverTemplates?.whatsapp

    return defaultLabel || null
  } catch (error) {
    console.warn('Error getting default WhatsApp template label:', error)
    return null
  }
}

export function getDefaultEmailSubjectAndBody(
  notification,
  isCustom?: boolean
): { subject?: string; html?: string, smsText?: string } {
  const { notificationType, receiverType, channel } = notification
  if ((!notificationType && !receiverType)) {
    return { subject: '', html: '', smsText: '' }
  }
  if (channel === 'whatsapp') {
    // WhatsApp notifications have no default template - user must select one
    return { subject: '', html: '', smsText: '' }
  }
  if (channel === 'sms') {
    // Guest receiver type is not supported for SMS notifications
    if (receiverType === 'guest') {
      return { smsText: '', subject: '', html: '' }
    }
    return { smsText: DEFAULT_TEMPLATES[notificationType][receiverType].sms.text, subject: '', html: '' }
  }
  if (notificationType === 'confirmation' && receiverType === 'guest') {
    return isCustom
      ? DEFAULT_TEMPLATES[notificationType][receiverType].email.customLink
      : DEFAULT_TEMPLATES[notificationType][receiverType].email.default
  }
  return DEFAULT_TEMPLATES[notificationType][receiverType].email as {
    subject: string
    html: string
  }
}
